"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatRequestEvent = exports.parseJwt = exports.getCookie = void 0;
var getCookie = function (name) {
    if (typeof document === 'undefined') {
        return null;
    }
    var matches = document.cookie.match(new RegExp("(;\\s)?".concat(name, "=")));
    if (!matches || matches.length == 0 || matches.index === undefined) {
        return null;
    }
    var endIndex = document.cookie.indexOf(';', matches.index + 1);
    var startIndex = matches.index + matches[0].length;
    var value = endIndex === -1
        ? document.cookie.substr(startIndex)
        : document.cookie.substring(startIndex, endIndex);
    return decodeURIComponent(value);
};
exports.getCookie = getCookie;
function parseJwt(token) {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(atob(base64)
        .split('')
        .map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    })
        .join(''));
    return JSON.parse(jsonPayload);
}
exports.parseJwt = parseJwt;
/**
 * Event objects are created using FQNs, e.g., `com.vimeo.workspace.click_cta`,
 * where `com.vimeo.workspace` is the namespace and `click_cta` is the event name.
 *
 * However, fresnel expects the name in the request to be formatted as
 * `com_vimeo_workspace.click_cta`.
 *
 * So this function replaces any dots in the namespace with underscores.
 */
function formatRequestEvent(event) {
    var parts = event.split('.');
    if (parts.length <= 2) {
        return event;
    }
    var eventName = parts.pop();
    return "".concat(parts.join('_'), ".").concat(eventName);
}
exports.formatRequestEvent = formatRequestEvent;
//# sourceMappingURL=index.js.map